var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('a',{attrs:{"href":"http://www.tecnograph-group.com"}},[_vm._v("Powered by Tecnograph © "+_vm._s(new Date().getFullYear()))])])}
var staticRenderFns = []

export { render, staticRenderFns }